import insightTracker from '@finance/perfsdk';
import LevelConfig from '@credit/level-sdk';
import { localeInfo } from 'umi';
import SAP from '@shopee/web_enhance_sap';
import { stores } from '@/stores/useStore';
import { metricConfigs } from './utils/v2/insight';
import { initIDAP } from './utils/v2/idap';
import remoteConfig from './utils/remote-config';

// 进行 insight 上报
try {
  initIDAP().then(() => {
    insightTracker.init({
      region: BIZ_COUNTRY,
      bizType: 'fastescrow',
      isLive: REACT_APP_ENV === 'live',
      getUser: () => stores?.userInfo?.userInfo?.userId ?? '',
      xhr: (params: Record<string, any>) => {
        console.log('insight', params);
        stores?.userInfo?.requestInsight(params);
      },
      ignore: {
        ignoreApis: ['fe_chat', 'web-performance', 'web-custom'],
      },
      metricConfigs,
    });
    console.log('start init insight tracker');
  });
} catch (error) {
  console.error('init insight tracker error', error);
}

SAP.hook().addSameOriginFilter().init();

// 初始化uc配置平台配置
remoteConfig.initConfig();

export function onRouteChange({ matchedRoutes, location }: any) {
  if (!['dev', 'stable', 'mock'].includes(REACT_APP_ENV)) {
    let url = location?.pathname;
    if (/\/billing\/repay-result/.test(url)) {
      url = '/billing/repay-result';
    }
  }

  if (!Array.isArray(matchedRoutes) || !matchedRoutes.length) {
    return false;
  }
}

// 确保在页面渲染之前，先拉取 cdn 的配置
export function render(oldRender: any) {
  if (['ph', 'th'].includes(BIZ_COUNTRY)) {
    // 如果是dev环境则转为test环境下的配置
    const envName = ['dev', 'stable', 'mock', 'test1', 'uat'].includes(REACT_APP_ENV)
      ? 'test'
      : REACT_APP_ENV;

    new LevelConfig({
      resources: {
        jump: `https://cdn.scredit.sg/${BIZ_COUNTRY}/jump/__level__/${envName}/urls.json`,
      },
      localeInfo,
    })
      .init()
      .catch(() => {})
      .finally(() => {
        oldRender();
      });
  } else {
    oldRender();
  }
}
